import { render, staticRenderFns } from "./AdminDetalleGastosViaje.vue?vue&type=template&id=20b053a2&"
import script from "./AdminDetalleGastosViaje.vue?vue&type=script&lang=js&"
export * from "./AdminDetalleGastosViaje.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "AdminDetalleGastosViaje.vue"
export default component.exports